import dayjs from 'dayjs'

/**
 * Filtre türüne göre tarih aralığı hesaplar
 *
 * @param {String} filterType - Tarih filtresi türü (today, thisWeek, vb.)
 * @returns {Object|null} - Başlangıç ve bitiş tarihleri
 */
export const getDateRangeForFilter = (filterType) => {
  if (!filterType) return null

  const now = dayjs()
  let startDate, endDate

  switch (filterType) {
    case 'today':
      startDate = now.startOf('day')
      endDate = now.endOf('day')
      break
    case 'yesterday':
      startDate = now.subtract(1, 'day').startOf('day')
      endDate = now.subtract(1, 'day').endOf('day')
      break
    case 'thisWeek':
      startDate = now.startOf('week')
      endDate = now.endOf('week')
      break
    case 'lastWeek':
      startDate = now.subtract(1, 'week').startOf('week')
      endDate = now.subtract(1, 'week').endOf('week')
      break
    case 'thisMonth':
      startDate = now.startOf('month')
      endDate = now.endOf('month')
      break
    case 'lastMonth':
      startDate = now.subtract(1, 'month').startOf('month')
      endDate = now.subtract(1, 'month').endOf('month')
      break
    default:
      return null
  }

  return {
    startDate: startDate.format('YYYY-MM-DD'),
    endDate: endDate.format('YYYY-MM-DD'),
  }
}